import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  purple2,
  purple6,
  purple7,
  grey3,
  grey4,
  grey5,
  grey6,
  grey7,
  grey1,
} from 'approot/shared/styles/colours.style';
import { spacing8 } from 'approot/shared/styles/spacing.style';
import {
  baseFlexCss,
  flexCentreAlignCss,
} from 'approot/shared/styles/flex.style';

const LABEL_HEIGHT = 26;

type RadioInputWrapperProps = {
  $disabled?: boolean;
};

export const MultipleChoiceRadioInputLabel = styled.label<RadioInputWrapperProps>`
  display: flex;
  cursor: pointer;
  margin-bottom: 0;
  width: 100%;

  ${({ $disabled }) =>
    $disabled &&
    `
      color: ${grey6};
      ${MultipleChoiceRadioInputDecor} {
        background-color: ${grey3};
      }
  `};
`;

export const MultipleChoiceRadioInputFieldWrapper = styled.div`
  height: ${rem(LABEL_HEIGHT)};
  display: flex;
  align-items: center;
  align-self: center;
  flex: 0 0 auto; // needs to be explicitly set for ie11, so that RadioInputDecor's margin doesn't collapse
`;

export const MultipleChoiceRadioInputField = styled.input`
  opacity: 0;
  position: absolute;
  z-index: 1; // necessary for the hover to work in IE
  cursor: pointer;
`;

type RadioInputDecorProps = {
  $isSelected?: boolean;
};

export const MultipleChoiceRadioInputDecor = styled.div<RadioInputDecorProps>`
  ${flexCentreAlignCss}
  border: ${rem(1)} solid ${grey7};
  background-color: ${grey1};
  box-sizing: border-box;
  height: ${rem(24)};
  width: ${rem(24)};
  border-radius: 50%;
  flex-shrink: 0;
  margin-right: ${rem(spacing8)};
  outline: none;

  & > div {
    height: ${rem(12)};
    width: ${rem(12)};
    top: ${rem(3)};
    left: ${rem(3)};
    border-radius: 50%;
    background-color: transparent;
  }

  ${({ $isSelected }) =>
    $isSelected &&
    `
      border: ${rem(1)} solid ${purple7};
      & > div {
        background-color: ${purple7};
      }
  `}

  // ACTIVE STATES
  input:checked + & {
    border: ${rem(1)} solid ${purple7};
  }
  input:checked + & > div {
    background-color: ${purple7};
  }

  // FOCUS STATES
  input:focus + & {
    box-shadow: 0 0 0 4px ${grey4};
    background-color: ${grey4};
  }
  input:focus:checked + & {
    box-shadow: 0 0 0 4px ${purple2};
    background-color: ${purple2};
  }

  // HOVER STATES
  input:hover + &,
  input:hover:checked + & {
    border: ${rem(1)} solid ${purple6};
  }
  input:hover:checked + & > div {
    background-color: ${purple6};
  }

  // DISABLED STATES
  input:disabled + &,
  input:disabled:checked + & {
    box-shadow: none;
    border: ${rem(1)} solid ${grey5};
  }
  input:disabled:checked + & {
    background-color: ${grey3};
  }
  input:disabled:checked + & > div {
    background-color: ${grey6};
  }
`;

export const MultipleChoiceRadioInputTextWrapper = styled.div`
  ${baseFlexCss}
  width: 100%;
`;
